import React from "react";
import { useNavigate } from "react-router-dom";
import './home.css';

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <div className="button-container">
        <button className="animated-button" onClick={() => navigate("/nbc")} >
          Go to Subaru NBC Event
        </button>
        <button className="animated-button" onClick={() => navigate("/abc")} >
          Go to Subaru ABC Event
        </button>
      </div>
    </div>
  );
};

export default Home;